export default "__VITE_ASSET__BppjC8b5__"